import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { css } from '@emotion/react';
import ReactRouterLink from '../ReactRouterLink';
import Link from '../Link';
import useMessageService from '../../services/i18n/useMessageService';
import { UnauthenticatedPaths, AuthenticatedPaths } from '../../constants/Paths';
import FooterLanguageSelect from './FooterLanguageSelect';

const LegalFooterDesktop = () => {
    const [
        [
            privacyPolicyLabel = 'Privacy Policy',
            copyRightLabel = 'Copyright 2010-{0} Veeva',
            learnMoreLabel = 'Learn More',
        ],
        messagesLoading,
    ] = useMessageService([
        'legal_footer.privacy_policy',
        'legal_footer.copyright',
        'general.learn_more',
    ]);
    const [isFooterOneLine, setIsFooterOneLine] = useState(true);
    const privacyPolicyAndLanguageSection = useRef(null);
    const copyrightAndLearnMoreSection = useRef(null);

    useEffect(() => {
        if (!messagesLoading) {
            const privacyPolicyAndLanguageSectionWidth =
                privacyPolicyAndLanguageSection.current?.getBoundingClientRect().width;
            const copyrightAndLearnMoreSectionWidth =
                copyrightAndLearnMoreSection.current?.getBoundingClientRect().width;
            if (privacyPolicyAndLanguageSectionWidth + copyrightAndLearnMoreSectionWidth > 500) {
                setIsFooterOneLine(false);
            } else {
                setIsFooterOneLine(true);
            }
        }
    }, [messagesLoading]);
    const { pathname } = useLocation();

    return (
        <div
            css={[
                css`
                    font-size: 1rem;
                    display: flex;
                    width: 100%;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: center;
                    flex-direction: column;
                `,
                isFooterOneLine &&
                    css`
                        justify-content: space-between;
                        flex-direction: row;
                    `,
            ]}
        >
            <div ref={copyrightAndLearnMoreSection}>
                <Link
                    css={css`
                        font-size: 1rem;
                    `}
                    href="https://www.veeva.com/veeva-id/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {privacyPolicyLabel}
                </Link>
                {pathname !== AuthenticatedPaths.VAULT_INVITES && (
                    <>
                        <span
                            css={css`
                                margin-right: 0.3333rem;
                                margin-left: 1rem;
                            `}
                        >
                            |
                        </span>
                        <FooterLanguageSelect />
                    </>
                )}
            </div>
            <div ref={privacyPolicyAndLanguageSection}>
                <span
                    css={({ black }) => css`
                        margin-left: auto;
                        text-align: right;
                        color: ${black};
                    `}
                >
                    {copyRightLabel?.replace('{0}', new Date().getFullYear().toString())}
                </span>
                <span
                    css={css`
                        margin: 0 0.3333rem;
                    `}
                >
                    |
                </span>
                <ReactRouterLink
                    to={UnauthenticatedPaths.LEARN_MORE}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {learnMoreLabel}
                </ReactRouterLink>
            </div>
        </div>
    );
};

export default LegalFooterDesktop;
